import { getFiltersFromUrl } from 'src/routes/SearchPage/utils';

export const getFiltersCount = () => Object.keys(getFiltersFromUrl()).length;

export const areEqual = (prevProps, nextProps) =>
  nextProps.filters === prevProps.filters &&
  nextProps.mapView === prevProps.mapView;
